<template>
  <div class="index-use">
    <div class="w1200 animate_top in index-use-box" style="display: block">
      <h2 v-if="element.titleBarName">{{ element.titleBarName }}</h2>
      <p class="index-user-box-desc" v-if="element.titleBarDesc">{{ element.titleBarDesc }}</p>
      <div class="index-use-tab" v-if="childItem.propsValue.data.length > 1">
        <div
          :class="'index-use-tab-item' + (index == 0 ? ' active' : '')"
          v-for="(item, index) in childItem.propsValue.data"
          :key="index"
        >{{ item.customField1 }}</div>
      </div>
      <div class="index-use-line" v-if="childItem.propsValue.data.length > 1"></div>
      <div class="index-line" v-if="childItem.propsValue.data.length > 1"></div>
      <div class="index-use-con">
        <div
          :class="'index-use-case fadeIn' + (index == 0 ? ' active' : '')"
          v-for="(item, index) in childItem.propsValue.data"
          :key="index"
        >
          <img :src="isString(item.customField3) ? item.customField3 : item.customField3.contentImage | imgUrl" />
          <img
              v-if="!isString(item.customField3) && item.customField3.contentType == 'video'"
              class="video-block-play"
              src="https://mks.yybip.com/group1/M00/01/F7/CgoRDGSAPjeATLhuAAAHsdousik151.png"
            />
          <p>{{ item.customField2 }}</p>
        </div>
        <a class="index-btn" v-if="childItem.propsValue.buttonInfo.text">{{ childItem.propsValue.buttonInfo.text }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import {
  buttonObject,
  contentObject
} from "@/modules/autoweb/config/elementObject.js";
export default {
  name: "MkYingyongchangjingWeb",
  props: {
    element: {
      type: Object,
      default: () => {
        return {};
      }
    },
    childItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      fields: [
        {
          code: "customField1",
          label: "标题",
          type: "text"
        },
        {
          code: "customField2",
          label: "描述",
          type: "text"
        },
        {
          code: "customField3",
          label: "素材",
          type: "content",
          contentType: "image,video",
          defaultType: "image",
          width: 1000,
          height: 600,
          isMultiple: false
        }
      ],
      buttonInfo: _.cloneDeep(buttonObject),
      data: [
        {
          customField1: "标题1",
          customField2: "这里输入描述信息",
          customField3: _.cloneDeep(contentObject)
        },
        {
          customField1: "标题2",
          customField2: "这里输入描述信息",
          customField3: _.cloneDeep(contentObject)
        },
        {
          customField1: "标题3",
          customField2: "这里输入描述信息",
          customField3: _.cloneDeep(contentObject)
        },
        {
          customField1: "标题4",
          customField2: "这里输入描述信息",
          customField3: _.cloneDeep(contentObject)
        }
      ]
    };
  },
  methods: {
    isString(value) {
      if (Object.prototype.toString.call(value) === "[object String]") {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>


<style lang="scss">
.index-use {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: top left;
  background-size: 100% 100%;
}
.index-use-box {
  position: relative;
  h2 {
    font-weight: bold;
    font-size: 30px;
    letter-spacing: 2px;
    color: #e31924;
    text-align: center;
    padding: 30px 0;
    margin: 0 auto;
  }
  .index-user-box-desc {
    width: 100%;
    font-size: 20px;
    color: #727272;
    line-height: 26px;
    text-align: center;
    margin: 0px 0 20px 0;
  }
  .index-use-tab {
    padding-bottom: 18px;
    display: flex;
    justify-content: space-between;

    .index-use-tab-item {
      flex: 1;
      text-align: center;
      font-size: 20px;
      font-weight: bold;
      line-height: 23px;
      letter-spacing: 1px;
      color: #707070;
      cursor: pointer;
    }
    .index-use-tab-item.active,
    .index-use-tab-item:hover {
      color: #e31824;
    }
  }
  .index-use-line {
    width: 75px;
    height: 4px;
    background-color: #e31924;
    position: absolute;
    left: 70px;
  }
  .index-line {
    width: 1200px;
    height: 1px;
    background-color: #000000;
    opacity: 0.1;
    margin-top: 4px;
  }
  .index-use-con {
    width: 100%;
    // margin-top: 34px;
    // height: 602px;
    .index-use-case {
      text-align: center;
      width: 100%;
      display: none;
      img {
        max-width: 90%;
      }
      .video-block-play {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 50px;
        height: 50px;
      }
      p {
        font-size: 20px;
        font-weight: bold;
        line-height: 26px;
        letter-spacing: 1px;
        color: #e31824;
        margin: 0 auto;
      }
    }
    .active {
      display: block;
    }
    .fadeIn {
      -webkit-animation-duration: 0.5s;
      -webkit-animation-timing-function: ease;
      -webkit-animation-fill-mode: both;
      -moz-animation-duration: 0.5s;
      -moz-animation-timing-function: ease;
      -moz-animation-fill-mode: both;
      -o-animation-duration: 0.5s;
      -o-animation-timing-function: ease;
      -o-animation-fill-mode: both;
      -ms-animation-duration: 0.5s;
      -ms-animation-timing-function: ease;
      -ms-animation-fill-mode: both;
      animation-duration: 0.5s;
      animation-timing-function: ease;
      animation-fill-mode: both;
      -webkit-animation-name: fadeIn;
      -moz-animation-name: fadeIn;
      -o-animation-name: fadeIn;
      animation-name: fadeIn;
    }
    .index-btn {
      margin: 30px auto;
    }
    a.index-btn {
      display: block;
      width: 220px;
      height: 46px;
      line-height: 46px;
      color: #ffffff;
      font-size: 18px;
      text-align: center;
      background-image: linear-gradient(131deg, #e5732d 0%, #e31924 52%);
      border-radius: 6px;
    }
  }
}
</style>
